import React from "react";
import { Col, Row } from "reactstrap";
import PeopleIcon from "@material-ui/icons/People";
import LiveTvIcon from "@material-ui/icons/LiveTv";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import {
  Typography,
  Accordion,
  AccordionSummary,
} from "@material-ui/core";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import PersonIcon from "@material-ui/icons/Person";
import BrokenImageIcon from "@material-ui/icons/BrokenImage";

const sectionStyle = {
  padding: "10px 17px",
  borderRadius: "5px",
  background: "#c6c6c638",
  margin: "0px",
  marginBottom:"5px",
  color: "#fff",
  width: "100%",
  display: "inline-flex",
};

export const ActiveInfo = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const {
    clientList,
    presenterList,
    moderatorList,
    meetingList,
    activeSpeaker,
  } = props;

  let speaker = props.activeSpeaker
    ? props.attendees.find((a) => a.badgeNo === activeSpeaker.badgeNo)
    : null;

  const renderPersonTypeConnectivity = () => {
    const { personTypes, attendees, clientList } = props;
    const personTypesList = {};
    if (personTypes.length > 0) {
      personTypes.map((pt) => {
        personTypesList[pt.name.trim()] = 0;
      });
      clientList.map((cl) => {
        let client = attendees.find((a) => a.badgeNo === cl.clientKey);
        if (client) {
          let clientPTypes = client.personTypes;

          if (clientPTypes) {
            clientPTypes.map((cpt) => {
              let pt = personTypes.find((pt) => pt.personTypeId === cpt);
              if (pt) {
                let typeName = pt.name.trim();
                personTypesList[typeName] += 1;
              }
            });
          }
        }
      });
      meetingList.map((cl) => {
        let client = attendees.find((a) => a.badgeNo === cl.clientKey);
        if (client) {
          let clientPTypes = client.personTypes;

          if (clientPTypes) {
            clientPTypes.map((cpt) => {
              let pt = personTypes.find((pt) => pt.personTypeId === cpt);
              if (pt) {
                let typeName = pt.name.trim();
                personTypesList[typeName] += 1;
              }
            });
          }
        }
      });
    }
    const elements = [];
    for (const key in personTypesList) {
      if (personTypesList.hasOwnProperty(key)) {
        elements.push(
          <Row>
            <Col className="col-2 text-left"></Col>
            <Col className="col-6 text-left text-secondary">{key}</Col>
            <Col className="col-4 text-right text-primary">
              <Typography
                className="primary-text"
                style={{ marginLeft: "10px", fontSize: "1.2rem" }}
              >
                {" "}
                {personTypesList[key]}
              </Typography>
            </Col>
          </Row>
        );
      }
    }
    return elements;
  };
  const sortChannel = () => {
    const channels = [];
    meetingList
      .filter((m) => m.channel != null)
      .map((c, i) => {
        if (!channels.find((cl) => cl.channel == c.channel)) {
          channels.push({
            connections: meetingList
              .filter((m) => m.channel == c.channel)
              .length.toString(),
            channel: c.channel,
          });
        }
      });
    return channels;
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const channels = sortChannel();
  return (
    <div 
    ref={props.setActiveInfoRef}
      className="dark-list"
      style={{
        margin: 0,
        padding: "0px 0px",
        paddingTop:"10px",
        maxHeight: "41%",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          ...sectionStyle,
          display: "inline-block",
          padding: "0px 18px",
        }}
        className="dark-card"
      >
        <Accordion className="dark-card" style={{ padding: "0px 13px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="primary-text" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="dark-card"
            style={{
              display: "inline-flex",
              padding: "0px",
              width: "100%",
            }}
          >
            <Row style={{ width: "100%" }}>
              <Col className="col-2 text-left primary-text">
                <PeopleIcon />
              </Col>
              <Col className="col-6 text-left" style={{ paddingLeft: "22px" }}>
                <span style={{ fontFamily: "Roboto", color: "#fff" }}>
                  <SystemLabel name="Connections" />
                </span>
              </Col>
              <Col className="col-2 text-left"></Col>
              <Col className="col-2 text-right">
                <Typography
                  className="primary-text"
                  style={{ marginLeft: "10px", fontSize: "1rem" }}
                >
                  {meetingList.length + clientList.length}
                </Typography>
              </Col>
            </Row>
          </AccordionSummary>
          <AccordionDetails
            style={{
              display: "inline-block",
              width: "100%",
              padding: "10px 0px",
            }}
          >
            <Row>
              <Col className="col-2 text-left primary-text">
                <MeetingRoomIcon />
              </Col>
              <Col className="col-6 text-left ">
                <span style={{ fontFamily: "Roboto", color: "#fff" }}>
                  {channels.length > 0 ? (
                    <SystemLabel name="MainRoom" />
                  ) : (
                    <SystemLabel name="MeetingClients" />
                  )}
                </span>
              </Col>
              <Col className="col-2 text-left"></Col>
              <Col className="col-2 text-right">
                <Typography
                  className="primary-text"
                  style={{ marginLeft: "10px", fontSize: "1rem" }}
                >
                  {meetingList.length.toString()}
                </Typography>
              </Col>
            </Row>

            {channels.map((c, i) => {
              return (
                <Row
                  key={i}
                  style={{ marginLeft: 10, marginTop: i == 0 ? 10 : 0 }}
                >
                  <Col className="col-2 text-left primary-text">
                    <BrokenImageIcon />
                  </Col>
                  <Col className="col-6 text-left">
                    <span style={{ fontFamily: "Roboto", color: "#fff" }}>
                      <SystemLabel name="Channel" /> {"  "}
                      {c.channel}
                    </span>
                  </Col>
                  <Col className="col-2 text-left"></Col>
                  <Col className="col-2 text-right">
                    <Typography
                      className="primary-text"
                      style={{ marginLeft: "10px", fontSize: "1rem" }}
                    >
                      {c.connections}
                    </Typography>
                  </Col>
                </Row>
              );
            })}
            {clientList.length > 0 ? (
              <Row>
                <Col className="col-2 text-left primary-text">
                  <PersonIcon />
                </Col>
                <Col className="col-6 text-left">
                  <span style={{ fontFamily: "Roboto", color: "#fff" }}>
                    <SystemLabel name="Clients" />
                  </span>
                </Col>
                <Col className="col-2 text-left"></Col>
                <Col className="col-2 text-right">
                  <Typography
                    className="primary-text"
                    style={{ marginLeft: "10px", fontSize: "1rem" }}
                  >
                    {clientList.length.toString()}
                  </Typography>
                </Col>
              </Row>
            ) : null}
          </AccordionDetails>
        </Accordion>
      </div>
      <div style={sectionStyle} className="dark-card">
        <Col className="col-2 text-left">
          <LiveTvIcon />
        </Col>
        <Col className="col-6 text-left">
          <span style={{ fontFamily: "Roboto", color: "#fff" }}>
            <SystemLabel name="Presenters" />
          </span>
        </Col>
        <Col className="col-2 text-left"></Col>
        <Col className="col-2 text-right">
          <Typography
            className="primary-text"
            style={{ marginLeft: "10px", fontSize: "1rem" }}
          >
            {presenterList.length.toString()}
          </Typography>
        </Col>
      </div>
      <div style={sectionStyle} className="dark-card">
        <Col className="col-2 text-left">
          <VerifiedUserIcon />
        </Col>
        <Col className="col-6 text-left">
          <span style={{ fontFamily: "Roboto", color: "#fff" }}>
            <SystemLabel name="Moderators" />
          </span>
        </Col>
        <Col className="col-2 text-left"></Col>
        <Col className="col-2 text-right">
          <Typography
            className="primary-text"
            style={{ marginLeft: "10px", fontSize: "1rem" }}
          >
            {moderatorList.length.toString()}
          </Typography>
        </Col>
      </div>
  
      {props.personTypes && props.personTypes.length > 0 ? (
        <div
          style={{
            ...sectionStyle,
            display: "inline-block",
            padding: "0px 17px",
          }}
          className="dark-card"
        >
          <Accordion className="dark-card" style={{ padding: "0px 13px" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="primary-text" />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="dark-card"
              style={{
                display: "inline-flex",
                padding: "0px",
                width: "100%",
              }}
            >
              <Row>
                <Col className="col-2 text-left primary-text">
                  <SupervisedUserCircleIcon />
                </Col>
                <Col
                  className="col-8 text-left primary-text"
                  style={{ paddingLeft: "22px" }}
                >
                  <span style={{ fontFamily: "Roboto", color: "#fff" }}>
                    <SystemLabel name="ActivePersonTypes" />
                  </span>
                </Col>
                <Col className="col-2 text-left"></Col>
              </Row>
            </AccordionSummary>
            <AccordionDetails
              style={{ display: "inline-block", width: "100%", padding: "0px" }}
            >
                 {renderPersonTypeConnectivity().map((e, i) => {
                    return <React.Fragment key={i}>{e}</React.Fragment>;
                  })}
            </AccordionDetails>
          </Accordion>
        </div>
      ) : null}
      {speaker ? (
        <div
          style={{ ...sectionStyle, cursor: "pointer" }}
          onClick={props.showSpeaker}
          className="dark-card"
        >
          <Col className="col-2 text-left">
            <RecordVoiceOverIcon />
          </Col>
          <Col className="col-4 text-left">
            <span style={{ fontFamily: "Roboto", color: "#fff" }}>
              <SystemLabel name="ActiveSpeaker" />
            </span>
          </Col>
          <Col className="col-6 text-right">
            <span style={{ fontFamily: "Roboto" }}>
              <strong>{`${speaker.name}`}</strong>
            </span>
          </Col>
        </div>
      ) : null}
    </div>
  );
};
